
import React from "react";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, omit } from "lodash";
import { Button, Input, Typography, Modal, Table, Space } from "antd";
import { Popover, Tooltip } from "@mui/material";
import { getCountryLocals } from "store/adminPanel/actions";
import ActionList from "../languageConfig/components/ActionList";
import { ReactComponent as ActionsIcon } from '../../../../../assets/icons/more_dots.svg';
import { Checkbox, Select } from "components";
import EditModal from "./components/editModal";
import RestoreModal from "./components/restoreModal";
import DeleteModal from "./components/deleteModal";
import SearchComponent from "./components/SearchComponent";

const LanguageConfig = () => {

  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const locals = useSelector((state => state.adminPanel.countryStrings));
  const [displayedValues, setDisplayedValues] = useState([]);
  const [language, setLanguage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLocal, setSelectedLocal] = useState("");
  const [open, setOpen] = useState(Boolean(anchorEl));
  const [editOpen, setEditOpen] = useState(false);
  const [restoreOpen, setRestoreOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [restored, setRestored] = useState(false);
  const startIndex = (currentPage - 1) * 10;
  const endIndex = startIndex + 10;
  const displayedItems = displayedValues && displayedValues.slice(startIndex, endIndex);

  useEffect(() => {
    dispatch(getCountryLocals(language));
    setRestored(false);
  }, [language, restored]);
  // useEffect(() => {
  //   if(locals){
  //     setDisplayedValues(locals);
  //   }
  // }, [locals]);
  useEffect(() => {
    if (locals) {
      const sortedLocals = [...locals].sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    
      setDisplayedValues(sortedLocals);
    }
  }, [locals]);

  const [checked, setChecked] = useState(false);
  const [selectedLocals, setSelectedLocals] = useState([]);

  const checkAll = () => {
    if(checked){
        setChecked(false);
        setSelectedLocals([]);
    }
    else{
        const uniqueValuesSet = new Set([
        ...selectedLocals,
        ...displayedItems.map(item=>item.name)
        ]);
        const uniqueValuesArray = Array.from(uniqueValuesSet);
        setSelectedLocals(uniqueValuesArray);
        setChecked(true);
    }
}
const handleCheck = (name) => {
    if(selectedLocals.includes(name)){
        const tempSelectedLocals = selectedLocals.filter(item => item != name);
        setSelectedLocals(tempSelectedLocals);
    } else {
        setSelectedLocals([...selectedLocals, name]);
    }
}

  const columns = [
    {
      title: <Checkbox checked={checked} onChange={()=>checkAll()}></Checkbox>,
      dataIndex: 'name',
      render: (value) => {
          return <Checkbox checked={selectedLocals.includes(value)} onChange={()=>handleCheck(value)}></Checkbox>;
      }
  },
    {
      title: "Names",
      dataIndex: 'name',
      key: 'name',
      width:"43.75rem"

    },
    {
      title: "LocalString",
      dataIndex: 'localString',
      key: 'localString',
      width:"40rem"
    },
    {
      title: "",
      fixed: 'right',
      key: "action",
      align: "right",
      width:"3.75rem",
      render: (text, record) => {
        return (
            <Space align="end">
                <Tooltip title="Actions">
                    <ActionsIcon aria-describedby={record.name} onClick={(e) => onMoreClick(record)(e)} style={{ cursor: "pointer"}} />
                </Tooltip>
            </Space>
        );
      },
    },
  ];

  const handlePageChange = page => {
    setCurrentPage(page);
    setChecked(false);
    setSelectedLocals([]);
  };
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const onMoreClick = (local) => (event) => {
    setSelectedLocal(local);
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  return (
    <div id="users-config-page">
      <SearchComponent
        displayedValues={displayedValues} 
        setDisplayedValues={setDisplayedValues} 
        allLocals={locals}
        className='shrunk'
      />
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px", marginTop:"50px" }}>
        <Select
          showSearch={false}
          size="large"
          style={{width:"200px", marginBottom:"10px"}}
          placeholder="Select language"
          value={language}
          onChange={value=>{setLanguage(value)}}
          options={[
            { value: 'GR', label: 'Greek' },
            { value: 'EN', label: 'English' },
          ]}
        />
        <div style={{width:"100%", display: "flex", alignItems: "center", gap: "10px", justifyContent:"right", alignItems:"right"}}>
        <Button className="config-delete" type="primary" onClick={()=>setDeleteOpen(true)}>Delete</Button>
        <Button className="config-language-create" type="default">Add new string</Button>
        <Button disabled={language ? false : true} className="config-language-create" type="default" onClick={()=>setRestoreOpen(true)}>Restore</Button>
        </div>
      </div>
      <Table 
        className="results-table"
        dataSource={displayedValues} 
        columns={columns} 
        pagination={{ showSizeChanger: false, showTitle: false, onChange: handlePageChange}}
      />
      <div>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center', 
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          // style={{marginLeft:"160px"}}
        >
          <ActionList open={()=>setOpen()} anchorEl={()=>setAnchorEl()} name={selectedLocal} setEditOpen={setEditOpen}/>
        </Popover>
      </div>
      <RestoreModal
        isVisible={restoreOpen}
        setVisible={setRestoreOpen}
        selectedLocal={selectedLocal}
        setSelectedLocal={setSelectedLocal}
        setRestored={setRestored}
      />
      <EditModal
        isVisible={editOpen}
        setVisible={setEditOpen}
        local={selectedLocal}
        country={language}
      />
      <DeleteModal
        isVisible={deleteOpen}
        setVisible={setDeleteOpen}
        selectedLocals={selectedLocals}
        setSelectedLocals={setSelectedLocals}
      />
    </div>
  )
};

export default LanguageConfig;